import { ReactNode } from "react";

export const Stat = ({
  label,
  value,
  className = ""
}: {
  label: string;
  value: string | number | ReactNode;
  className?: string;
}) => {
  return (
    <div className={className}>
      <h3 className="mb-2 text-xs text-content-400">{label}</h3>
      {
        // if value is react node, render it directly
        typeof value === "string" || typeof value === "number" ? (
          <p className="text-sm text-content-1000 font-medium truncate">
            {value}
          </p>
        ) : (
          value
        )
      }
    </div>
  );
};
